import api from '../../../../App/socket';

export const removeUserAddress = (address_id, user_id) => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'NestedDelete',
        options: {
            fullPath: `person.addresses.${address_id}`,
            where: {
                _id: user_id,
            },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_addresses_requests/remove_user_addresses_request.js